export default context => {
    const moduleId = context.getters.moduleId;

    const dateStartId = `${moduleId}_additional-questions_date-start-complaint`;

    context.dispatch('complaintDateValidation', {
        root: true,
    }).then(() => {
        if (context.rootState[dateStartId].value.length) {
            context.commit(`${moduleId}/ADD_TRACKED_ERRORS`, [
                dateStartId,
            ], {
                root: true,
            });
        } else {
            context.commit(`${moduleId}/REMOVE_TRACKED_ERRORS`, [
                dateStartId,
            ], {
                root: true,
            });
        }
    });
};